import { isPlatformMobileIOS } from 'common/Prose/utils/platformSniffing'
import { MarkType, ResolvedPos } from 'prosemirror-model'

export function getMarkBoundaries($cursor: ResolvedPos, markType: MarkType) {
  let startIndex = $cursor.index()
  let endIndex = $cursor.indexAfter()

  if (isPlatformMobileIOS()) {
    startIndex = Math.max(startIndex - 1, 0)
  }

  const hasMark = (index: number) => markType.isInSet($cursor.parent.child(index).marks)

  while (endIndex < $cursor.parent.childCount && hasMark(endIndex)) {
    endIndex++
  }

  let startPos = $cursor.start()
  let endPos = startPos

  for (let i = 0; i < endIndex; i++) {
    let size = $cursor.parent.child(i).nodeSize
    if (i < startIndex) startPos += size
    endPos += size
  }

  return { from: startPos, to: endPos }
}
